export default __webpack_public_path__ + "static/media/12.fc8db387.jpeg";